<template>
  <form>
    <PageHeader title="apollo-RP - 作業内容マスタ" class="list">
      <template #title-header-content></template>
      <template #page-header-content>
          <div class="mb-auto pl-4 flex items-center h-10">
            <h1 class="text-lg font-bold text-white flex items-center">            
              <Icon iconName="DocumentText" class="w-7 h-7 mr-2" /> <span class="mt-0">作業内容コード 一覧・編集</span>
            </h1>
            <div v-if="auth" class="pl-2 mb-100px ml-auto">
              <PrimaryButton text="新規" size="normal hover:bg-pink-400" class="new" @click="edit(null)"/>
            </div>
          </div>
      </template>
    </PageHeader>
    <main class="absolute top-32 w-screen bottom-4 -mt-2 leading-8 list">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="table">
            <thead class="th sticky top-0">
              <tr class="column">
                  <th class="th1">コード</th>
                  <th class="th2">大項目（作業内容区分名）</th>
                  <th class="th2">小項目（作業内容名）</th>
                  <th v-if="auth" class="th1"></th>
                  <th v-if="auth" class="th1"></th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in list" :key="index">
              <tr :class="setColor(index)">
                <!-- コード -->
                <td class="td1">{{row.code}}</td>
                <!-- 大項目（作業内容区分名） -->
                <td class="td2">{{row.category}}</td>
                <!-- 小項目（作業内容名） -->
                <td class="td2">{{row.detail}}</td>
                
                <td v-if="auth" class="td1"><PrimaryButton text="編集" @click="edit(list[index])" /></td>
                <td v-if="auth" class="td1"><PrimaryButton text="削除" @click="deleteData(list[index])" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
    <!-- 作業コード編集・新規登録モーダル -->
    <EstimateWorkCodeEditModal 
      v-model="modalShow"
      :target="editData"
      :open="modalShow"
      :allList="list"
      @modalClose="modalClose"
    />
  </form>
</template>
<script>

import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import * as estimateManager from '@managers/estimateManager'
import EstimateWorkCodeEditModal from '../components/EstimateWorkCodeEditModal.vue'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import * as utils from '@libs/utils'
import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    Icon,
    PrimaryButton,
    PageHeader,
    EstimateWorkCodeEditModal
  },

  data() {
    return {
      // 作業区分マスタリスト
      list: [],
      // モーダル表示
      modalShow: false,
      // 編集する内容
      editData: {},
      // 編集権限
      auth: false
    }
  },

  created() {
    this.getData()
  },

  methods: {
    /**
     * データ取得
     */
    async getData() {
      // 管理者権限がある場合
      if (this.$store.getters.auth && this.$store.getters.auth.adminAuth) {
        this.auth = true
      }

      let d = await estimateManager.getWorkCode(this)
      if (d.length > 0) {

        // 並び替え
        let sortList = []
        sortList = d.sort(function(a, b) {
          return (Number(a.code) > Number(b.code)) ? 1 : -1;
        });
        this.list = utils.clone(sortList)
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      this.modalShow = true
      this.editData = data
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      }
    },

    /**
     * モーダルを閉じる
     */
    modalClose() {
      this.modalShow = false
      this.getData()
    },

    /**
     * 削除イベント
     * @param list 削除するデータ
     */
    async deleteData(list) {
      const dialogResult = await dialogs.showWarningConfirmDialog('削除', '作業区分（' + list.code + '）を削除してよろしいですか？')
      if (dialogResult === 'YES') {
        let registApp = await estimateManager.deleteWorkCode(this, list.code)
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '削除できませんでした。')
          return
        }
        logManager.recording(this, logManager.Loglevel.INFO, '作業区分マスタ', '削除', '作業区分（' + list.code + '）を削除しました。')
        await this.getData()
      }
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
}

.column th {
  height: 50px;
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.th1 {
  width: 200px;
  text-align: center;
}

.th2 {
  text-align: left;
  padding-left: 30px;
}

.td1 {
  text-align: center;
}

.td2 {
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.new {
  margin-top: 103px;
  width: 200px;
  background: #eb94c8;
}

@media screen and (max-width: 1400px) {
  .list {
    min-width: 1400px !important;
  }
}
</style>